import { Card, CardContent, Stack, SvgIconTypeMap, Typography } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { PropsWithChildren } from 'react';

interface HomeCardPropertioes {
  title: string;
  subtitle: string;
  SvgIcon: OverridableComponent<SvgIconTypeMap>;
}

const HomeCard = ({ title, subtitle, SvgIcon, children }: PropsWithChildren<HomeCardPropertioes>) => {
  return (
    <Card sx={{ width: '100%', overflow: 'hidden' }}>
      <CardContent>
        <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" gap={2} width="100%">
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={2} width="100%">
            <Typography variant="body1" color="text.secondary">
              {title}
            </Typography>
            <SvgIcon color="secondary" />
          </Stack>

          {children}

          <Typography variant="body2" color="text.disabled">
            {subtitle}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default HomeCard;
